import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PollSingleAbstract } from '../../../../../abstracts/poll-single.abstract';
import { FormGroup } from '@angular/forms';
import { ToastController } from 'ionic-angular';
import { IClientConfig } from '../../../../../models/client.model';
import { has } from 'lodash';
import { UtilitiesProvider } from '../../../../../providers/utilities';

@Component({
  selector: 'app-event-rating-question',
  templateUrl: 'event-rating-question.html'
})

export class EventRatingQuestionComponent extends PollSingleAbstract implements OnInit, OnChanges {

  /*
    --- IMPORTANT ---
    In this component we can not create a reactive form,
    beacause the star rating library only support ng-model,
    but we use the output declared on pollSingleAbstract
  */

  @Input('clientConfig')
  public clientConfig: IClientConfig;

  public form: FormGroup;

  @Input('questionId')
  public questionId: string;

  @Input('userAnswer')
  public userAnswer: any;

  @Input('lastQuestion')
  public lastQuestion: boolean;

  @Input('userHasRecord')
  public userHasRecord: boolean;

  public value = 0;

  constructor(
    public toastCtrl: ToastController,
    private utilitiesData: UtilitiesProvider
  ) {
    super(toastCtrl);
  }

  ngOnInit() {
    this.checkAnswers();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (has(changes, 'questionId') && changes.questionId.firstChange === false) {
      this.value = 0;
      this.utilitiesData.consoleWarn('Change Question Id', this.questionId);
    }
    if (has(changes, 'userAnswer') && changes.userAnswer.firstChange === false) {
      this.value = 0;
      this.utilitiesData.consoleWarn('Change user Answer', this.userAnswer);
    }
  }

  public submitRating() {
    if (this.value > 0) {
      this.sendAnswer.emit({ id: this.questionId, value: this.value });
    } else {
      this.showMessage('Respuesta inválida, por favor califique de acuerdo a su decisión');
    }
  }

  public checkAnswers() {
    if (this.userAnswer) {
      this.value = this.userAnswer;
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/poll-event/components/event-poll-questions/event-rating-question/event-rating-question.ts